export const actionTypes = {
    fetchUsers : 'FETCH_USERS',
    receiveUsers : 'RECEIVE_USERS',
    receiveUser : 'RECEIVE_USER',
    saveUser : 'SAVE_USER',
    setUser : 'SET_USER',
    clearUser : 'CLEAR_USER'

};